import {Dispatch} from 'react'
import {State} from '../../reducers'
import {generalOpenModalError, generalShowLoader} from '../general.actions'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {SUSCRIPCION_TYPES} from '../../constants/suscripcion.types'
import {SuscripcionAction} from '../../interfaces/suscripcion.interface'
import {KEYS} from '../../constants/keysStorage'

// ******************************************************************************************
export const suscripcionSetDatosSuscripcion = (datos: any) => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_SET_DATOS_SUSCRIPCION,
  payload: datos,
})

export const suscripcionSetSuscripciones = (suscripciones: any) => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_SET_SUSCRIPCIONES,
  payload: suscripciones,
})

export const suscripcionSetSuscripcionesFiltradas = (suscripciones: any) => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_SET_SUSCRIPCIONES_FILTRADAS,
  payload: suscripciones,
})

export const suscripcionSetSeleccion = (seleccion: any) => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_SET_SELECCION,
  payload: seleccion,
})

export const suscripcionSetDetallePago = (detalle: any) => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_SET_DETALLE_PAGO,
  payload: detalle,
})

export const suscripcionSetValidarSaldo = (validate: any) => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_SET_VALIDAR_SALDO,
  payload: validate,
})

export const suscripcionClear = () => ({
  type: SUSCRIPCION_TYPES.SUSCRIPCION_CLEAR,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const suscripcionGetDatosSuscripcion =
  () => async (dispatch: Dispatch<SuscripcionAction>) => {
    await dispatch(generalShowLoader(true))
    let username = localStorage.getItem(KEYS.USERNAME_CLIENTE)
    let message = 'No se lograron obtener los datos de la suscripción.'

    await http
      .get(ENDPOINTS.SUSCRIPCION_GET_DATOS, {username})
      .then(async (res: any) => {
        if (res?.status === 200 || res?.message === 'Usuario encontrado.') {
          dispatch(suscripcionSetDatosSuscripcion(res?.data))
          if (res?.data?.suscripciones?.EmpresaSuscripcions && Array.isArray(res.data.suscripciones.EmpresaSuscripcions)) {
            dispatch(suscripcionSetSuscripciones(res.data.suscripciones.EmpresaSuscripcions))
            dispatch(suscripcionSetSuscripcionesFiltradas(res.data.suscripciones.EmpresaSuscripcions))
          }
          return
        }
        await dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err: any) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const GetValidarSaldo = () => async (dispatch: Dispatch<SuscripcionAction>) => {
  await dispatch(generalShowLoader(true))
  let message = 'No se logró validar el saldo del usuario.'
  let CodigoEmpresa = localStorage.getItem(KEYS.CODIGO_EMPRESA)

  await http
      .post(ENDPOINTS.SUSCRIPCION_GET_VALIDAR_SALDO, {CodigoEmpresa})
      .then(async (res: any) => {
        if (res?.body && res?.errorCode === 0 ) {
          dispatch(suscripcionSetValidarSaldo(res?.body?.Saldo))
          return
        }
        await dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err: any) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
}

export const suscripcionPostDetallePago =
  () => async (dispatch: Dispatch<SuscripcionAction>, getState: () => State) => {
    const numero = getState().suscripcion.seleccion?.numero
    if (!numero) return
    await dispatch(generalShowLoader(true))
    const body = {
      id_detalle: getState().suscripcion.seleccion.numero,
      id_usuario: localStorage.getItem(KEYS.ID_CLIENT),
    }
    let message = 'No se logró obtener los datos del detalle de pago.'

    await http
      .post(ENDPOINTS.SUSCRIPCION_POST_DETALLE_PAGO, body)
      .then(async (res: any) => {
        if (res?.status === 200 || res?.message === 'Registro encontrado.') {
          dispatch(suscripcionSetDetallePago(res.data))
          return
        }
        await dispatch(generalOpenModalError(res?.message ?? message))
      })
      .catch(async (err: any) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

  export const apiSubirComprobante = (body: any) => http.post(ENDPOINTS.SUSCRIPCION_POST_SUBIR_COMPROBANTE, body)
  export const apiSubirComprobanteGeneral = (body: any) => http.post(ENDPOINTS.SUSCRIPCION_POST_SUBIR_COMPROBANTE_GENERAL, body)
  export const apiGetComprobante = (params: any) => http.get(ENDPOINTS.SUSCRIPCION_GET_COMPROBANTE, params)
  export const apiGetReciboCliente = (params: any) => http.get(ENDPOINTS.SUSCRIPCION_GET_RECIBO_CLIENTE, params)
